import React, { useState, useEffect } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { get1BpersonalInfo, getAppId, getEmail, getStageID, setApplicantBirthDate, setTStageID } from "../utility/Common";
import Header from "./layout/Header";
import { createNotification } from "./Popup";
import { applicationManagementMasilingi } from "../utility/services/apiService";
import { getResource } from "../utility/services/resources";
import { messages } from "../utility/services/message";
import NavBar_appID from "./layout/NavBar_appID";
import Footer from "./layout/Footer";
import CentryReusableComponent from "./CentryReusableComponent";
import { personalInfoB } from "../formValidation/FormValidator";

function Step_oneB() {
  let navigate = useNavigate();
  // const personalInfoData = useLocation();
  // var Stage = personalInfoData.state?.DocStageID;
  // var Stage = getStageID();

  const [BirthVillage, setBirthVillage] = useState("");
  const [countries, setCountries] = useState([]);
  const [territories, setTerritories] = useState([]);
  const [territoryID, setTerritoryID] = useState();
  const [countryId, setCountryID] = useState();
  const [regions, setRegions] = useState([]);
  const [regionsId, setRegionID] = useState();
  const [districts, setDistricts] = useState([]);
  const [districtsId, setDistrictsID] = useState();
  const [wards, setWards] = useState([]);
  const [wardsId, setWardsID] = useState();
  const [stageID, setStageID] = useState(null);
  const { checkApplicationStage } = CentryReusableComponent({});
  const [isLoading, setIsLoading] = useState(false)
  const [errors, setErrors] = useState({});
  //======Lookups
  useEffect(() => {
    fetchCountries();
    setPersonalnfo();
  }, []);

  const setPersonalnfo = () => {
    checkApplicationStage(2)
    //  const data = personalInfoData?.state;
    const data = get1BpersonalInfo()
    setStageID(data?.DocStageID);
    setCountryID(data?.CountryID);

    setTerritoryID(data?.TeritoryID);
    if (data?.CountryID) {
      fetchTerritory(data?.CountryID);
    }
    setRegionID(data?.RegionID);
    if (data?.TeritoryID) {
      fetchRegions(data?.TeritoryID, data?.CountryID);
    }
    setDistrictsID(data?.DistrictID);
    if (data?.RegionID) {
      fetchDistricts(data?.RegionID);
    }
    setWardsID(data?.BirthWardID);
    if (data?.DistrictID) {
      fetWards(data?.DistrictID);
    }
    setBirthVillage(data?.BirthVillage);
  };

  //======fetchCountries
  const fetchCountries = async () => {
    const result = await getResource("Country", "null", "null", "lookup");
    if (Array.isArray(result) && result.length > 0) {
      setCountries(result);
    } else {
      setCountries([]);
    }
  };

  //======selectCountry
  const getCountryIDChange = (e) => {
    const countryID = e.target.value;
    setCountryID(countryID);
    setWardsID(countryID);
    fetchTerritory(countryID);
  };
  const fetchTerritory = async (territoryId) => {
    const result = await getResource(
      "TerritoryByCountry",
      territoryId,
      "null",
      "lookup"
    );
    if (Array.isArray(result) && result.length > 0) {
      setTerritories(result);
    } else {
      setTerritories([]);
    }
  };

  //======selectTerritory
  const getTerritoryIDChange = (e) => {
    const territoryID = e.target.value;
    setTerritoryID(territoryID);
    fetchRegions(territoryID, countryId);
  };

  const fetchRegions = async (territoryID, countryID) => {
    const result = await getResource(
      "RegionBirth",
      territoryID,
      countryID,
      "lookup"
    );
    if (Array.isArray(result) && result.length > 0) {
      setRegions(result);
    } else {
      setRegions([]);
    }
  };

  //======selectRegion
  const getRegionIDChange = (e) => {
    const regionID = e.target.value;
    setRegionID(regionID);
    fetchDistricts(regionID);
  };
  const fetchDistricts = async (regionID) => {
    const result = await getResource(
      "DistrictByRegionID",
      regionID,
      "null",
      "lookup"
    );
    if (Array.isArray(result) && result.length > 0) {
      setDistricts(result);
    } else {
      setDistricts([]);
    }
  };

  //======selectDistrict
  const getDistrictIDChange = (e) => {
    const districtID = e.target.value;
    setDistrictsID(districtID);
    fetWards(districtID);
  };
  const fetWards = async (districtId) => {
    const result = await getResource(
      "WardByDistrict",
      districtId,
      "null",
      "lookup"
    );
    if (Array.isArray(result) && result.length > 0) {
      setWards(result);
    } else {
      setWards([]);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    //Refresh
    const Stage = stageID ?? 210;

    const formData = {
      Action: Stage == 210 ? "Insert" : "Update",
      ApplicationId: getAppId(),
      EmailAddress: getEmail(),
      BirthVillage,
      BirthWardID: wardsId,
    };
    const navigateToStage = (stage, message) => {
      const routes = {
        210: "/stp1B",
        220: "/stp2",
        230: "/stp3",
        240: "/stp4",
        250: "/stp5",
        260: "/stp6",
        270: "/stp7",
      };
      navigate(routes[stage] || "/continue");
      createNotification({ type: "success", message })();
    };

    const newErrors = personalInfoB(formData);
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      setErrors({});
      setIsLoading(true);
      applicationManagementMasilingi(formData, "add_missing_personal_info")
        .then((result) => {
          if (result.code == 1) {
            if (result.data) {
              const stID = result?.data[0]?.StageID
              setTStageID(stID)
              setPersonalnfo(result?.data[0])
              if (Stage == 210 && formData.Action == "Insert") {
                navigate("/stp2");
              } else if (Stage == 220 && formData.Action == "Update") {
                navigate("/stp2");
              } else {
                navigateToStage(Stage, result.message);
              }
              setApplicantBirthDate(result?.data[0]?.DateOfBirth);
            } else if (
              result.code == 3 ||
              result.message.toLowerCase().includes("expire")
            ) {
              createNotification({ type: "error", message: "Session expired" })();
              navigate("/");
            } else {
              createNotification({ type: "error", message: result.message })();
            }
          }
        })
        .catch((error) => {
          console.log(error)
          createNotification({ type: "error", message: messages.networkError })();
        });
    };
  }
  return (
    <>
      <Header />
      <div className="container">
        <NavBar_appID />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12 module-content2">
            <div
              className="col-md-12 col-sm-12 col-xs-12 tab-registration-container"
              style={{ marginTop: "-5px" }}
            >
              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 tab-registration-menu hidden-xs">
                <div className="list-group">
                  <Link to="#" className="list-group-item active">
                    Habari Binafsi
                  </Link>
                  <Link className="list-group-item ">Anuwani ya Makazi </Link>
                  <Link className="list-group-item ">Habari za Wazazi </Link>
                  <Link className="list-group-item ">Habari za Safari</Link>
                  <Link className="list-group-item ">Wakati wa Dharura</Link>
                  <Link className="list-group-item ">Viambatanisho </Link>
                  <Link className="list-group-item ">Tamko Rasmi </Link>
                  <Link className="list-group-item ">Malipo </Link>
                  <Link className="list-group-item ">Kamilika </Link>
                </div>
              </div>
              <div
                className="col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-registration-tab"
                style={{ marginTop: "1px", paddingRight: "1px" }}
              >
                <div className="tab-registration-content active">
                  <form id="step-one-form" onSubmit={handleSubmit}>
                    <div className="box box-default">
                      <div className="box-header with-border">
                        <h3 className="box-title">Mahali pa Kuzaliwa</h3>
                      </div>
                      <div className="box-body">
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label
                                className="control-label"
                                htmlFor="BirthCountryID"
                              >
                                Nchi
                              </label>
                              <select
                                id="BirthCountryID"
                                className="form-control"
                                name="BirthCountryID"
                                onChange={getCountryIDChange}
                                value={countryId}
                                required
                              >
                                <option value="">Chagua Nchi</option>
                                {countries.length > 0 &&
                                  countries?.map((country) => (
                                    <option
                                      key={country.id}
                                      value={country.ResourceID}
                                    >
                                      {country.ResourceName}
                                    </option>
                                  ))}
                              </select>
                              <p className="help-block help-block-error"></p>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label
                                className="control-label"
                                htmlFor="BirthTerritoryID"
                              >
                                Eneo
                              </label>

                              <select
                                id="eneo"
                                className="form-control"
                                name="eneo"
                                onChange={getTerritoryIDChange}
                                value={territoryID}
                                required
                              >
                                <option value="">Chagua Eneo</option>
                                {territories.length > 0 &&
                                  territories?.map((territory) => (
                                    <option
                                      key={territory.id}
                                      value={territory.ResourceID}
                                    >
                                      {territory.ResourceName}
                                    </option>
                                  ))}
                              </select>
                              <p className="help-block help-block-error"></p>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label
                                className="control-label"
                                htmlFor="BirthRegionID"
                              >
                                Mkoa
                              </label>

                              <select
                                id="mkoa"
                                className="form-control"
                                onChange={getRegionIDChange}
                                value={regionsId}
                                name="mkoa"
                                required
                              >
                                <option value="">Chagua Mkoa</option>
                                {regions.length > 0 &&
                                  regions?.map((region) => (
                                    <option
                                      key={region.ResourceID}
                                      value={region.ResourceID}
                                    >
                                      {region.ResourceName}
                                    </option>
                                  ))}
                              </select>
                              <p className="help-block help-block-error"></p>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label
                                className="control-label"
                                htmlFor="BirthDistrictID"
                              >
                                Wilaya
                              </label>
                              <select
                                id="DistrictID"
                                className="form-control"
                                onChange={getDistrictIDChange}
                                value={districtsId}
                                name="DistrictID"
                                required
                              >
                                <option value="">Chagua Wilaya</option>
                                {districts.length > 0 &&
                                  districts?.map((district) => (
                                    <option
                                      key={district.ResourceID}
                                      value={district.ResourceID}
                                    >
                                      {district.ResourceName}
                                    </option>
                                  ))}{" "}
                              </select>
                              <p className="help-block help-block-error"></p>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label
                                className="control-label"
                                htmlFor="BirthWardID"
                              >
                                Kata/Shehia
                              </label>
                              <select
                                id="BirthWardID"
                                className="form-control"
                                name="BirthWardID"
                                onChange={(e) => setWardsID(e.target.value)}
                                value={wardsId}
                                required
                              >
                                <option value="">Chagua Kata/Shehia</option>
                                {wards.length > 0 &&
                                  wards?.map((ward) => (
                                    <option
                                      key={ward.ResourceID}
                                      value={ward.ResourceID}
                                    >
                                      {ward.ResourceName}
                                    </option>
                                  ))}
                              </select>
                              <p className="help-block help-block-error"></p>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label
                                className="control-label"
                                htmlFor="BirthVillage"
                              >
                                Mtaa/Kijiji
                              </label>
                              <input
                                type="text"
                                id="BirthVillage"
                                className="form-control"
                                name="BirthVillage"
                                onChange={(e) => {
                                  const regex = /^[a-zA-Z '-]*$/;
                                  const value = e.target.value.toUpperCase();
                                  if (regex.test(value) || value === "") {
                                    setBirthVillage(value);
                                  }
                                }}
                                value={BirthVillage}
                                required
                              />
                              <p className="help-block help-block-error"></p>
                            </div>
                          </div>
                        </div>
                      </div>
                      {errors && (
                        <div className="help-block help-block-error">
                          {Object.values(errors).map((error, index) => (
                            <p className="help-block help-block-error" key={index}>{error}</p>
                          ))}
                        </div>
                      )}
                    </div>
                    <div className="box-footer">
                      <div className="row">
                        <div className="col-md-4">
                          <Link
                            to="/"
                            type="submit"
                            className="btn btn-labeled btn-block btn-default"
                          >
                            Hifadhi na Toka | <i className="fa fa-save"></i>
                          </Link>
                        </div>
                        <div className="col-md-4"></div>
                        <div className="col-md-4">
                          <button disabled={isLoading} className="btn btn-default btn-block btn-label-next">
                            {isLoading ? "Subiri.." : "Hifadhi na Endelea |"}
                            <i className="fa fa-angle-double-right"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}

export default Step_oneB;
